import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { PerformanceSection } from './components/PerformanceSection';
import { TeamSection } from './components/TeamSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { SEO } from './components/SEO';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0" data-mp="2mn5ash5h0lgp">
      <SEO data-id="element-1" data-mp="31aqeac69cmp5" />
      <Header data-id="element-2" data-mp="31agoaol7qfjg" />
      <main data-id="element-3" data-mp="31aysc7e49y1x">
        <HeroSection data-id="element-4" data-mp="31bs09botatln" />
        <AboutSection data-id="element-5" data-mp="31c1hoavsjsfq" />
        <ServicesSection data-id="element-6" data-mp="31cjou2jzrr2f" />
        <PerformanceSection data-id="element-7" data-mp="2wjgrrkg09zhh" />
        <TeamSection data-id="element-8" data-mp="2wj8ehrfz0s5r" />
        <ContactSection data-id="element-9" data-mp="2wip36tktt20p" />
      </main>
      <Footer data-id="element-10" data-mp="28u5z6q8t7bef" />
    </div>;
}